import React from "react";
import {Link} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import EncodeSansLight from '../../../assets/fonts/Encode_Sans/EncodeSans-Light.ttf';

const useStyles = makeStyles(() => ({
    btnCotizar: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "20px",
        background: "#BB0D66",
        padding: "10px 30px 10px 30px",
        marginLeft: "auto",
        marginRight: "auto",
        textDecoration: "none",
        border: "solid #BB0D66 0px",
        fontFamily: EncodeSansLight,
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    bannerBox: {
        backgroundColor: "#ffffff",
        borderRadius: "20px",
        width: "450px",
        height: "200px",
        boxShadow: "5px 10px 18px #888888",
    },
}))

const ProductBannerAlternative = (props) => {
    const productName = props.productName;
    const productIcon = props.productIcon;
    let componentToShow;
    const classes = useStyles();

    switch (productName) {
        case "AUTO":
            componentToShow = (
                <Link
                    to={{
                        pathname: `cotizar/vehiculo`,
                        state: {datosUser: props.datosUser}
                    }}
                    style={{textDecoration: "none", color: "#000"}}
                >
                    <button
                        className={classes.btnCotizar}
                        type={props.type}
                    >
                        Cotizar
                    </button>
                </Link>
            );
            break;
        case "MOTO":
            componentToShow = (
                <Link
                    to={{
                        pathname: `cotizar/motovehiculo`,
                        state: {datosUser: props.datosUser}
                    }}
                    style={{textDecoration: "none", color: "#000"}}
                >
                    <button
                        className={classes.btnCotizar}
                        type={props.type}
                    >
                        Cotizar
                    </button>
                </Link>
            );
            break;
        case "HOGAR":
            componentToShow = (
                <Link
                    to={{
                        pathname: `cotizar/combinado`,
                        state: {datosUser: props.datosUser}
                    }}
                    style={{textDecoration: "none", color: "#000"}}
                >
                    <button
                        className={classes.btnCotizar}
                        type={props.type}
                    >
                        Cotizar
                    </button>
                </Link>
            );
            break;
        case "MICROSEGUROS":
            componentToShow = (
                <Link
                    to={{
                        pathname: `cotizar/microseguro`,
                        state: {datosUser: props.datosUser}
                    }}
                    style={{textDecoration: "none", color: "#000"}}
                >
                    <button
                        className={classes.btnCotizar}
                        type={props.type}
                    >
                        Cotizar
                    </button>
                </Link>
            );
            break;
        case "OTROS SEGUROS":
            componentToShow = (
                <Link
                    to={{
                        pathname: `cotizar/otros`,
                        state: {datosUser: props.datosUser}
                    }}
                    style={{textDecoration: "none", color: "#000"}}
                >
                    <button
                        className={classes.btnCotizar}
                        type={props.type}
                    >
                        Cotizar
                    </button>
                </Link>
            );
            break;
    }

    return (
        <React.Fragment>
            <div
                className={classes.bannerBox}
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    margin:"24px"

                }}
            >
                <div style={{
                    width: "40%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                }}>
                    <img
                        style={{
                            width: "auto",
                            height: "104px"
                        }}
                        src={productIcon}
                        alt="producto"
                    />
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "60%",
                        alignItems: "center"
                    }}
                >
                    <p
                        className="font-face-encode-sans-extra-bold product-name"
                        style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            textAlign: "center",
                            marginBottom: "16px"
                        }}
                    >
                        {productName}
                    </p>
                    {componentToShow}
                </div>
            </div>
        </React.Fragment>
    );
};

export default ProductBannerAlternative;
